import { SxProps, Theme } from '@mui/material';

// Table styles
export const tableContainerStyles: SxProps<Theme> = {
    height: '100%',
    maxHeight: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    WebkitOverflowScrolling: 'touch',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0
};

export const tableStyles: SxProps<Theme> = {
    tableLayout: 'fixed',
    minWidth: 650
};

// Header cell styles
export const headerCellStyles: SxProps<Theme> = {
    bgcolor: '#F9FAFB'
};

export const headerTypographyStyles: SxProps<Theme> = {
    color: '#475467',
    fontFamily: 'Be Vietnam Pro',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 500,
};

// Row styles
export const tableRowStyles: SxProps<Theme> = {
    '&:hover': { bgcolor: '#f5f5f5' }
};

export const inactiveRowStyles: SxProps<Theme> = {
    bgcolor: '#f0f0f0'
};

export const recommendationRowStyles: SxProps<Theme> = {
    '&:hover': { bgcolor: '#f5f5f5' },
    bgcolor: '#fafafa'
};

// Drag handle styles
export const dragHandleBoxStyles: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: 1
};

export const dragIconButtonStyles: SxProps<Theme> = {
    cursor: 'inherit',
    pointerEvents: 'none'
};

export const menuIconStyles: SxProps<Theme> = {
    color: '#999'
};

// Expand/collapse icon styles
export const expandIconStyles: SxProps<Theme> = {
    fontSize: 20,
    color: '#999'
};

// Food column styles
export const foodBoxStyles: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5
};

export const foodImageStyles: SxProps<Theme> = {
    width: 52,
    height: 52,
    borderRadius: 1,
    objectFit: 'cover'
};

export const foodNameStyles: SxProps<Theme> = {
    color: '#101828',
    fontFamily: 'Be Vietnam Pro',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 500,
};

export const foodStoreStyles: SxProps<Theme> = {
    overflow: 'hidden',
    color: '#475467',
    textOverflow: 'ellipsis',
    fontFamily: 'Be Vietnam Pro',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 400,
};

// Price column styles
export const priceCellStyles: SxProps<Theme> = {
    padding: 0
};

export const priceBoxStyles: SxProps<Theme> = {
    bgcolor: '#F2F4F7',
    borderRadius: 2,
    border: '1px solid #EAECF0',
    display: 'flex',
    width: 80,
    padding: '4px 10px',
    justifyContent: 'center',
    alignItems: 'center',
};

export const priceTypographyStyles: SxProps<Theme> = {
    color: '#98A2B3',
    textAlign: 'center',
    fontFamily: 'Be Vietnam Pro',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 400,
};

// Checkbox styles
export const checkboxStyles: SxProps<Theme> = {
    color: '#e0e0e0',
    '&.Mui-checked': {
        color: '#2196f3'
    }
};

// Switch styles
export const switchStyles: SxProps<Theme> = {
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: '#2196f3'
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: '#2196f3'
    }
};

// Edit button styles
export const editButtonStyles: SxProps<Theme> = {
    color: '#666'
};

export const editIconStyles: SxProps<Theme> = {
    fontSize: 20
};

// Collapse styles
export const collapseCellStyles: SxProps<Theme> = {
    p: 0,
    border: 0
};

export const collapseTableStyles: SxProps<Theme> = {
    tableLayout: 'fixed',
    width: '100%'
};

// Recommendation specific styles
export const recoIconButtonStyles: SxProps<Theme> = {
    pointerEvents: 'none'
};

export const recoPriceCellStyles: SxProps<Theme> = {
    width: 62,
    padding: 0
};
